import http from "../http-common";


const getCountries = () => {
  return http.get("/get-countries-list");
};
const CountryService = {
    getCountries,
}
export default CountryService;